
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { QcReasonMstApi } from '../../api/master/qcreason-mst.api';
import { QcReasonMstData } from '../../interface/master/qcreason-mst';

@Injectable()
export class QcReasonMstService extends QcReasonMstData {

  constructor(private api: QcReasonMstApi) {
    super();
  }
  list(url: string): Observable<any[]> {
    return this.api.list(url);
  }
  getById(url:string): Observable<any>{
      return this.api.getById(url);
  }
  create(url: string, data:any): Observable<any> {
    return this.api.add(url,data);
  }
  update(url: string, data:any): Observable<any> {
    return this.api.update(url,data);
  }
  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
